var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription success"},[_vm._v("Synaxy vous remercie pour votre abonnement.")])
}
var staticRenderFns = []

export { render, staticRenderFns }